import { validatePlanningConstraints } from './planning-engine';
import { PlanningConstraints, PlanningSave } from './planning.types';

/** Includes hidden linked assignments, but never releases unrelated reservations. */
export function createPlanningSave(snapshot: PlanningConstraints, affected: ReadonlySet<string>): PlanningSave {
    validatePlanningConstraints(snapshot);
    if (snapshot.save_mode !== 'validated-plan' || affected.size === 0) throw new Error('No validated planning changes to save.');
    const assignments = snapshot.assignments.filter(row => affected.has(row.id));
    if (assignments.length !== affected.size || assignments.some(row => row.start_date == null || row.end_date == null)) throw new Error('The changed planning assignments are incomplete.');
    const tasks = new Set(assignments.map(row => row.task_id));
    if (snapshot.assignments.some(row => tasks.has(row.task_id) && !affected.has(row.id))) throw new Error('All assignments of a changed operation must be saved together.');
    return { version: 1, snapshot_id: snapshot.snapshot_id,
        assignments: assignments.map(row => ({ ...row })),
        reservations: snapshot.reservations.filter(row => row.assignment_id != null && affected.has(row.assignment_id)).map(row => ({ ...row })) };
}
